import React, { forwardRef } from 'react';
import BaseListItem from '@material-ui/core/ListItem';

const ListItem = forwardRef((props, ref) => (
  <BaseListItem ref={ref} {...props} />
));

export default ListItem;
